import { PRIVATE_ADMIN_EXTRA_INSTALLATION } from '../Constants/PathsConstant';
import InstallationExtraListView from '../Views/InstallationExtraListView';

export const InstallationExtraRouter = [
  {
    path: PRIVATE_ADMIN_EXTRA_INSTALLATION,
    children: [
      {
        index: true,
        element: <InstallationExtraListView />
      }
    ]
  }
];
